import classNames from 'classnames';
import * as React from 'react';

export const TimelineWrapper: React.FC<React.PropsWithChildren> = (props) => {
  const { children } = props;

  const containerRef = React.useRef<HTMLDivElement>(null);
  const contentRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!contentRef.current || !containerRef.current) return;
    /* 为了能让点击在Toolbox两边的时候能触发引擎的选中所以直接设置ml */
    containerRef.current.style.marginLeft = `-${contentRef.current.offsetWidth / 2}px`;
  });

  return (
    <div
      ref={containerRef}
      className={classNames(
        'absolute bottom-24 w-auto flex items-center justify-center left-1/2',
        '-ml-[253px]',
      )}
    >
      <div ref={contentRef}>{children}</div>
    </div>
  );
};
